import { RoleAction } from "src/Api/Enum/Role";
import { TableName } from "../table";
import type { CustomerPermission, TablePermission } from "./permission";
import {
  PermissionFactory,
  CRUD,
  VIEW_ONLY
} from "./permission";

const POM_LIMITS = [
  "deviceId",
  "latitude",
  "longitude",
  "areaId",
  "locationId",
  "viewId",
  "imageUrl",
  "capacityThreshold",
  "apiVersion",
];

export const partnerPermission = (
  customerPermissions: CustomerPermission[] = [],
  userRoles: string[] = [],
): TablePermission => ({
  [TableName.Customer]: [
    PermissionFactory.buildPermission(RoleAction.CREATE),
    PermissionFactory.buildPermission(RoleAction.UPDATE),
    PermissionFactory.buildPermission(RoleAction.DELETE),
  ],

  [TableName.Pom]: [
    PermissionFactory.buildPermission(RoleAction.VIEW),
    PermissionFactory.buildPermission(RoleAction.CREATE),
    PermissionFactory.buildPermission(RoleAction.UPDATE, POM_LIMITS),
  ],

  [TableName.Category]: VIEW_ONLY,

  [TableName.Tag]: CRUD,

  [TableName.View]: [
    PermissionFactory.buildPermission(RoleAction.VIEW),
    PermissionFactory.buildPermission(RoleAction.CREATE),
    PermissionFactory.buildPermission(RoleAction.UPDATE),
  ],

  [TableName.User]: CRUD,

  [TableName.ViewPom]: [
    PermissionFactory.buildPermission(RoleAction.VIEW),
    PermissionFactory.buildPermission(RoleAction.UPDATE, POM_LIMITS),
  ],

  [TableName.DisplayPom]: [
    PermissionFactory.buildPermission(RoleAction.VIEW),
    PermissionFactory.buildPermission(RoleAction.UPDATE, POM_LIMITS),
  ],

  [TableName.ViewWelcomePage]: [
    PermissionFactory.buildPermission(RoleAction.VIEW),
    PermissionFactory.buildFeaturePermission(
      RoleAction.SUMMARY_REPORT, "SUMMARY_REPORT", customerPermissions, userRoles
    ),
  ],

  [TableName.MapLocation]: VIEW_ONLY,

  [TableName.Manage]: VIEW_ONLY,
  [TableName.LegalInfo]: [
    PermissionFactory.buildFeaturePermission(
      RoleAction.VIEW, "PRIVACY_SECTION", customerPermissions, userRoles
    ),
  ],

  [TableName.Impersonation]: [
    PermissionFactory.buildPermission(RoleAction.IMPERSONATION),
  ],
  [TableName.LocationStatus]: VIEW_ONLY,
  [TableName.DisplayView]: [
    ...CRUD,
    PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_USER),
    PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_GROUP),
    PermissionFactory.buildFeaturePermission(
      RoleAction.DELETE_VIEW_ADVANCED, "DELETE_VIEW_ADVANCED", customerPermissions, userRoles
    ),
  ],
   [TableName.Ticketing]: [
    PermissionFactory.buildFeaturePermission(
      RoleAction.VIEW, "TICKETING", customerPermissions, userRoles
    ),
    PermissionFactory.buildFeaturePermission(
      RoleAction.CREATE, "TICKETING", customerPermissions, userRoles
    ),
    PermissionFactory.buildPermission(RoleAction.DIFFERENT_CUSTOMER_POM),
  ]
});